
import AppFrame from '../components/AppFrame'
import ListAudiences from '../components/ListAudience'

const AudiencesPage = () => (
    <ListAudiences />
)

export default AudiencesPage
